import _ from 'underscore'

export default {

    namespaced: true,

    modules: {},

    state: {

        data: []

    },

    getters: {

        list: function(state) {

            return _.sortBy(state.data, 'name')

        },

        associated: function(state) {

            var associated = {}

            _.each(state.data, function(item) {

                associated[item.id] = item

            })

            return associated

        }

    },

    mutations: {

        add: function(state, items) {

            _.each(items, function(item) {

                if (!_.contains(_.pluck(state.data, 'id'), item.id)) {

                    state.data.push(item)

                }

            })

        },

        update: function(state, data) {

            _.each(state.data, function(item) {

                if (item.id === data.id) {

                    item.name = data.name

                }

            })

        }

    },

    actions: {}

}
